import AiAssistentController from "./ai-assistent-controller";
import { withAuthRedirect } from "hoc/AuthRedirect";
import { connect } from "react-redux";
import { compose } from "redux";
import { getMe } from "store/account";
import { getValue } from "store/languages";
import { setShowPanel } from "store/header"
import { getStartDate, getEndDate } from "selectors/calendar-selector";
import { 
        sendMessageToAi, 
        loadAiUserSession, 
        loadAiSessions, 
        clearAiChat, 
        setSession, 
        loadAiStatistic, 
        loadAiHealth, 
        loadAiModels, 
        generateSessionTitle, 
        setErrorNotified 
} from "store/assistent";
import { setLeftMenuComponent, setRemoveLeftMenuComponent, setShowLeftMenu } from 'store/side-bar';

const mapStateToProps = (state) => ({
    startDate: getStartDate(state),
    endDate: getEndDate(state),
    isLoading: state.aiAssistant.isLoading,
    session: state.aiAssistant.session,
    messages: state.aiAssistant.messages,
    health: state.aiAssistant.health,
    models: state.aiAssistant.models,
    selectedLanguage: state.languages.selectedLanguage,
    error: state.aiAssistant.error,
    accountId: state.Account.id,
    companyId: state.Account.companyId,
    login: state.Account.login,
    leftMenuComponent: state.SideBarMenu.leftMenuComponent,
    showLeftMenu: state.SideBarMenu.showLeftMenu,
    deviceType: state.header.deviceType,
    errorNotified: state.aiAssistant.errorNotified
});

const mapDispatchToProps = {
    sendMessageToAi,
    loadAiUserSession,
    loadAiSessions,
    loadAiStatistic,
    clearAiChat,
    setSession,
    getMe,
    getValue,
    setLeftMenuComponent, setRemoveLeftMenuComponent, setShowLeftMenu,
    setShowPanel,
    loadAiHealth,
    loadAiModels,
    generateSessionTitle,
    setErrorNotified
};

const AiAssistentContainer = compose(
  withAuthRedirect,
  connect(mapStateToProps, mapDispatchToProps)
)(AiAssistentController);

export default AiAssistentContainer;